import React from 'react'
import { safeHtml } from '@library/dom'

import {
  AlignItems,
  Box,
  Color,
  Display,
  FlexDirection,
  Icon,
  IconVariant,
  Text,
} from '@gousto-internal/citrus-react'

import { RecipeGroupedItem } from './RecipesGrouped/RecipeGroupedItem'
import type { RecipesGroupedProps } from './RecipesGrouped/types'

export type { RecipePendingOperation, RecipePendingStates } from './RecipesGrouped/types'

const RecipeGroupTitle = ({ titleHTML }: { titleHTML: string }) => (
  <Box
    display={Display.Flex}
    alignItems={AlignItems.Center}
    gap={1}
    bg={Color.Secondary_50}
    color={Color.ColdGrey_900}
    paddingH={2}
    paddingV={1}
    style={{ borderRadius: '4px' }}
  >
    <Icon name="equipment" variant={IconVariant.Inherit} size={5} aria-hidden="true" />
    <Text color={Color.Inherit} dangerouslySetInnerHTML={safeHtml(titleHTML)} />
  </Box>
)

export const RecipesGrouped = ({
  basketRecipeIds,
  contentBlock,
  highlightedRecipeId,
  pendingStates = {},
  onClickRecipe,
  onEditRecipe,
  onRemoveRecipe,
}: RecipesGroupedProps) => (
  <Box
    display={Display.Flex}
    flexDirection={FlexDirection.Column}
    width="100%"
    height="100%"
    gap={4}
    data-testid="recipes-grouped"
  >
    <Box display={Display.Flex} flexDirection={FlexDirection.Column} gap={1}>
      <Text
        color={Color.ColdGrey_900}
        size={5}
        dangerouslySetInnerHTML={safeHtml(contentBlock.titleHTML)}
      />
      <Text
        color={Color.ColdGrey_900}
        dangerouslySetInnerHTML={safeHtml(contentBlock.descriptionHTML)}
      />
    </Box>
    {contentBlock.groups.map((group, groupIndex) => {
      const visibleItems = basketRecipeIds
        ? group.items.filter((item) => basketRecipeIds.has(item.id))
        : group.items

      if (basketRecipeIds && !visibleItems.length) return null

      return (
        <Box
          key={`${group.titleHTML}-${groupIndex}`}
          display={Display.Flex}
          flexDirection={FlexDirection.Column}
          gap={2}
          data-testid="recipe-group"
        >
          <RecipeGroupTitle titleHTML={group.titleHTML} />
          {visibleItems.map((item, itemIndex) => (
            <RecipeGroupedItem
              key={`${item.id}-${itemIndex}`}
              isHighlighted={item.id === highlightedRecipeId}
              item={item}
              pendingOperation={pendingStates[item.id]}
              onClickRecipe={onClickRecipe}
              onEditRecipe={onEditRecipe}
              onRemoveRecipe={onRemoveRecipe}
            />
          ))}
        </Box>
      )
    })}
  </Box>
)
